module.exports = __webpack_public_path__ + "img/vps_figure.12e6754.png";